import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ReportsService } from '../../../Services/reports.service';
import { DashboardService } from '../../../Services/dashboard.service';
import { UserManagementService } from '../../../Services/user-management.service';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { NoDataFoundComponent } from '../../no-data-found/no-data-found.component';
 
@Component({
  selector: 'app-on-off-business',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    NoDataFoundComponent,
  ],
  templateUrl: './on-off-business.component.html',
  styleUrls: ['./on-off-business.component.css'],
})
export class OnOffBusinessComponent implements OnInit {
  userTypes = [
    'All',
    'Individual Requestor',
    'Corporate Requestor',
    'Dumpster',
    'Dump Yard',
  ];
  cities = ['All', 'Abqaiq'];
  zones = ['All', 'AlMadinah', 'AlAndalus', 'AlRawadah', 'AlFeradious'];
  userPlatforms = ['All', 'Android', 'IOS'];
  userBusinessStatus = ['All', 'On Business', 'Off Business'];
  userApprovalforms = ['Approved', 'Yet to Approve'];
 
  selectedUserType: any;
  selectedCity: any;
  selectedZone: any;
  selectedPlatform: any;
  selectedBusinessStatus: any;
  selectedApprovalStatus: any;
  searchTerm: any;
 
  showFilterMenu: any = {
    userType: false,
    city: false,
    zone: false,
    platform: false,
    businessStatus: false,
    approvalStatus: false,
  };
 
  selectedZoneId: any;
  zoneList: any;
  userTypeList: any;
  cityList: any;
  selectedCityId: any;
  onOffBuisnessList: any;
  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;
  currentPage: any;
  originalTableData: any;
  nullStatus: any;
  activeTab: any = 'onBusiness';
  filterBuisnessUsers: any;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
 
  constructor(
    private reportService: ReportsService,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private dashService: DashboardService,
    private userService: UserManagementService
  ) {}
 
  // -------------------------------------- OnInit -------------------------------------- //
 
  ngOnInit() {
    this.getCity();
    this.getUserType();
    this.onOffBuisness();
    this.setActiveTab('onBusiness');
    
  }
 
  //  ----------------------------------- Get UserType List ----------------------------------- //
 
  getUserType() {
    this.reportService.getUserTypeList(apiEndPoints.userType).subscribe({
      next: (response: any) => {
        let userType = [1, 2, 3, 4];
        this.userTypeList = response.body.details?.filter((item: any) =>
          userType.includes(item.id)
        );
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }
 
  //  ----------------------------------- On UserType Change ----------------------------------- //
 
  onUserTypeChange(event: any) {
    const selectedUserType = (event.target as HTMLSelectElement).value;
    this.selectedUserType = selectedUserType;
    this.onOffBuisness();
  }
 
  // ----------------------------------- Get All City List API ----------------------------------- //
 
  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }
 
  // ----------------------------------- City Change Dropdown ----------------------------------- //
 
  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.getZone();
    this.onOffBuisness();
  }
 
  // ----------------------------------- Get All Zone List API ----------------------------------- //
 
  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }
 
  // ----------------------------------- Zone Change Dropdown ----------------------------------- //
 
  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.onOffBuisness();
  }
 
  // ----------------------------------- Get User On & Off business API ----------------------------------- //
 
  onOffBuisness() {
    this.userService
      .getOnOffBuisness(
        apiEndPoints.onOffBuisness,
        this.selectedUserType,
        this.selectedCityId,
        this.selectedZoneId
      )
      .subscribe({
        next: (response: any) => {
          console.log(response,'res');
          
          let allowedUserTypes = [
            'Individual Requester',
            'Corporate Requester',
            'Dumpster',
            'Dump yard',
          ];
          this.onOffBuisnessList = response.body.details.filter((data: any) =>
            allowedUserTypes.toString().toLowerCase().includes(data.userType.toString().toLowerCase())
          );
          console.log(this.onOffBuisnessList);
          this.filterBuisnessUsers = this.onOffBuisnessList;
          this.filterData();
        },
      });
  }
 
  // ----------------------------------- Active Tabs ----------------------------------- //
 
  setActiveTab(tab: any) {
    this.activeTab = tab;
    this.filterData();
    this.searchText = ''
let emptyKey = { target: { value: '' } };
this.search(emptyKey);
  }
 
 // ----------------------------- State ----------------------------- //
searchText: string = '';

// activeTab: string = 'onBusiness';

filterData() {
  // Always start from full list
  let data = [...this.onOffBuisnessList];

  // 1) Apply tab filter
  if (this.activeTab === 'onBusiness') {
    data = data.filter((d: any) => d.userBusinessStatus === 'On Business');
  } else if (this.activeTab === 'offBusiness') {
    data = data.filter((d: any) => d.userBusinessStatus === 'Off Business');
  }

  // 2) Apply search filter
  if (this.searchText) {
    const text = this.searchText.toLowerCase();

    data = data.filter((item: any) => {
      const userApprovalStatusText =
        item.userApprovalStatus === null
          ? 'Pending'
          : this.getStatus(item.userApprovalStatus, item.userType);

      return (
        (item.userType?.toLowerCase().includes(text)) ||
        (item.username?.toLowerCase().includes(text)) ||
        (item.companyName?.toLowerCase().includes(text)) ||
        (item.mobileNumber?.toString().includes(text)) ||
        (formatDate(item.userRegisteredDate, 'dd MMM yyyy', 'en-US')
          .toLowerCase()
          .includes(text)) ||
        (item.userPlatform?.toLowerCase().includes(text)) ||
        (item.platformVersion?.toString().toLowerCase().includes(text)) || 
        (item.userBusinessStatus?.toLowerCase().includes(text)) ||
        (userApprovalStatusText.toLowerCase().includes(text)) ||
        (item.city?.toLowerCase().includes(text)) ||
        (item.zone?.toLowerCase().includes(text))
      );
    });
  }

  // Save result
  this.filterBuisnessUsers = data;
}

// ----------------------------- Pagination ----------------------------- //
get pagedData() {
  const start = (this.page - 1) * this.pageSize;
  const end = this.page * this.pageSize;
  return this.filterBuisnessUsers?.slice(start, end);
}

onPageChange(page: number): void {
  this.page = page;
}

// ----------------------------- Search ----------------------------- //
search(event: any) {
  this.searchText = event?.target?.value?.toLowerCase().trim() || '';
  this.page = 1;
  this.filterData();   // ✅ re-apply filters
}


 
 
 
  toggleFilterMenu(menu: string) {
    this.showFilterMenu[menu] = !this.showFilterMenu[menu];
  }
 
 clearFilters(inputElement: HTMLInputElement) {
  let emptyKey = { target: { value: '' } };
this.search(emptyKey);
  inputElement.value = '';           // clear search box
  this.selectedUserType = 'All';
  this.selectedCity = 'All';
  this.selectedZone = 'All';
  this.selectedPlatform = 'All';
  this.selectedBusinessStatus = 'All';
  this.selectedApprovalStatus = 'All';
  this.searchTerm = '';
 
  // this.filterBuisnessUsers = [...this.onOffBuisnessList];  // restore full table
}
 
 
  getStatus(userApprovalStatus: any, userType: string): string {
    if (userApprovalStatus === true) {
      return 'Approved';
    } else if (
      userApprovalStatus === null &&
      userType == 'Individual Requester'
    ) {
      return userType === 'Individual Requester' ? 'Approved' : 'Pending';
    } else {
      return 'Pending';
    }
  }
 
  // Get continuous serial number across pages
getSerialNumber(index: number): number {
  return (this.page - 1) * this.pageSize + index + 1;
}
 
 
  // ------------------------------- Print List or Download PDF ------------------------------- //
 
  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'UserBuisness_List.pdf';
 
    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
 
      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );
 
        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );
 
        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );
 
          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );
 
          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);
 
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'User On & Off business List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });
 
          // Table headers
          const headers = [
            [
               { content: 'S.No' }, // added S.No
              { content: 'User' },
              { content: 'User Name' },
              { content: 'Mobile No' },
              { content: 'City' },
              { content: 'Zone' },
              { content: 'Date Registered' },
              { content: 'User Platform' },
              { content: 'Platform Version' },
              { content: 'User Business Status' },
              { content: 'User Approval Status' },
            ],
          ];
 
          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.onOffBuisnessList.forEach((user: any,index: number) => {
            const formattedDate = new Date(user.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
 
            tableBody.push([
              index + 1, // ✅ S.No
              user.userType,
              user.userType === 'Individual Requester'
                ? user.username
                : user.companyName,
              user.mobileNumber,
              user.city,
              user.zone,
              formattedDate,
              user.userPlatform,
              user.platformVersion,
              user.userBusinessStatus,
            ]);
          });
 
          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });
 
          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
 
  // ------------------------------- Export to Excel ------------------------------- //
 
  exportToExcel(): void {
    const formattedData = this.onOffBuisnessList.map((item: any,index: number) => ({
         'S.No': index + 1, // ✅ added S.No
      'User Type': item.userType,
      'User Name':
        item.userType === 'Individual Requester'
          ? item.username
          : item.companyName,
      'Mobile Number': item.mobileNumber,
      City: item.city,
      Zone: item.zone,
      'Date Registered': formatDate(
        item.userRegisteredDate,
        'dd MMM yyyy',
        'en-US'
      ),
      'User Platform': item.userPlatform,
      'Platform Version': item.platformVersion,
      'User Business Status': item.userBusinessStatus,
      'User Approval Status': item.userApprovalStatus,
    }));
 
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
 
    // Set column widths
    ws['!cols'] = [
      { wch: 20 }, // User Type
      { wch: 30 }, // User Name
      { wch: 15 }, // Mobile Number
      { wch: 20 }, // City
      { wch: 20 }, // Zone
      { wch: 20 }, // Date Registered
      { wch: 20 }, // User Platform
      { wch: 20 }, // Platform Version
      { wch: 25 }, // User Business Status
      { wch: 25 }, // User Approval Status
    ];
 
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'On&OffBuisness.xlsx');
  }
}